<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="pb10 card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка сотрудника
                </div>
                <div class="employer-id grey">
                    ID {{ employer.id }}
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="save" v-if="canEdit">
                    {{ saveBtnText }}
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start">
                <el-form :model="employer" label-position="top">
                    <el-row>
                        <el-col :span="24" class="card-general mb10 ml16">
                            <el-row>
                                <el-col :span="24">
                                    <div class="input-label">
                                        ФИО
                                    </div>
                                    <div :class="{ 'error-input': errors.full_name }">
                                        <el-input v-model="employer.full_name" size="mini" autocomplete="off" />
                                        <div class="error" v-if="errors.full_name">
                                            {{ errors.full_name[0] }}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.office_id }">
                                    <div class="input-label">
                                        Офис
                                    </div>
                                    <el-select v-model="employer.office_id" placeholder="" size="mini">
                                        <el-option
                                            v-for="office in offices"
                                            :key="office.id"
                                            :label="office.name"
                                            :value="office.id"
                                        />
                                    </el-select>
                                    <div class="error" v-if="errors.office_id">
                                        {{ errors.office_id[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.position_id }">
                                    <div class="input-label">
                                        Должность
                                    </div>
                                    <el-select
                                        v-model="employer.position_id"
                                        placeholder=""
                                        size="mini"
                                        @change="onChangePosition"
                                        :disabled="!canEditPosition"
                                    >
                                        <el-option
                                            v-for="position in positions"
                                            :key="position.id"
                                            :label="position.name"
                                            :value="position.id"
                                        />
                                    </el-select>
                                    <div class="error" v-if="errors.position_id">
                                        {{ errors.position_id[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors['user.email'] }">
                                    <div class="input-label">
                                        E-mail
                                    </div>
                                    <el-input size="mini" autocomplete="off" v-model="employer.user.email" />
                                    <div class="error" v-if="errors['user.email']">
                                        {{ errors['user.email'][0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.phone }">
                                    <div class="input-label">
                                        Телефон
                                    </div>
                                    <div class="el-input el-input--mini">
                                        <the-mask v-model="employer.phone" mask="+# (###) ###-##-##" placeholder="+7 (495) 123-45-67" class="el-input__inner" />
                                    </div>
                                    <div class="error" v-if="errors.phone">
                                        {{ errors.phone[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.internal_number }">
                                    <div class="input-label">
                                        Внутренний номер
                                    </div>
                                    <div class="el-input el-input--mini">
                                        <el-input size="mini" autocomplete="off" v-model="employer.internal_number" />
                                    </div>
                                    <div class="error" v-if="errors.internal_number">
                                        {{ errors.internal_number[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.icq }">
                                    <div class="input-label">
                                        ICQ
                                    </div>
                                    <el-input size="mini" autocomplete="off" v-model="employer.icq" />
                                    <div class="error" v-if="errors.icq">
                                        {{ errors.icq[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors.date_fired }">
                                    <div class="input-label">
                                        Дата увольнения
                                    </div>
                                    <div class="el-input el-input--mini">
                                        <el-date-picker
                                            v-model="employer.date_fired"
                                            type="date"
                                            placeholder="дд.мм.гггг"
                                            format="dd.MM.yyyy"
                                            value-format="dd.MM.yyyy"
                                            :picker-options="pickerOptions"
                                            :clearable="false"
                                            size="mini"
                                            class="w100"
                                        />
                                    </div>
                                    <div class="error" v-if="errors.date_fired">
                                        {{ errors.date_fired[0] }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" :class="{ 'error-input': errors['user.password'] }">
                                    <div class="input-label">
                                        Пароль
                                    </div>
                                    <el-input
                                        v-model="employer.user.password"
                                        :type="passwordInputType"
                                        size="mini"
                                        autocomplete="off"
                                    >
                                        <i
                                            class="el-icon-view el-input__icon"
                                            slot="suffix"
                                            @click="handleIconClick"
                                        >
                                        </i>
                                    </el-input>
                                    <div class="error" v-if="errors['user.password']">
                                        {{ errors['user.password'][0] }}
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.comment }" class="ml16 card-comment card-comment-employer">
                            <div class="input-label">
                                Комментарий
                            </div>
                            <el-input
                                size="mini"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder=""
                                v-model="employer.comment"
                            />
                            <div class="error" v-if="errors.comment">
                                {{ errors.comment[0] }}
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="16" class="card-wide">
                <div class="wrap-roles">
                    <div v-if="showRoles">
                        <el-row class="mt20" v-for="(section, key) in rolesMap" :key="key">
                            <el-col :span="24">
                                <div class="fnt-mid bold dark">
                                    {{ section.title }}
                                </div>
                                <el-row>
                                    <el-col :span="6" class="mt20" v-for="(subSection, subKey) in section.children" :key="subKey">
                                        <div class="dark">
                                            {{ subSection.title }}:
                                        </div>
                                        <div class="mt20">
                                            <el-checkbox-group
                                                v-model="employer.user_roles"
                                                size="medium"
                                                name="user_roles"
                                            >
                                                <div v-for="(role, childrenKey) in subSection.children" :key="childrenKey">
                                                    <el-checkbox :label="role.title" @change="checkboxChange(role.key)" />
                                                    <div v-if="checkViewOffice(role)" style="margin-left: 25px">
                                                        <div v-for="(office, officeId) in role.children" :key="officeId">
                                                            <el-checkbox-group
                                                                v-model="employer.roles_offices[role.key]"
                                                                size="medium"
                                                                name="roles_offices"
                                                            >
                                                                <el-checkbox :label="office.name" />
                                                            </el-checkbox-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-checkbox-group>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-row class="margin-msg">
                            <div class="wrap-icon-text text-center fnt-lg-s2 grey">
                                Доступа к дополнительной информации нет
                            </div>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import '@/assets/styles/card.scss';
import { pickerOptions } from '@/common/pickerOptions';

library.add(faCheck);

export default {
    name: 'EmployersCardEdit',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            pickerOptions,
            employer: {
                comment: null,
                full_name: null,
                id: null,
                office_id: null,
                phone: null,
                internal_number: null,
                position_id: null,
                date_fired: '',
                user: {
                    name: null,
                    email: null,
                    password: null
                },
                user_roles: [],
                roles_offices: []
            },
            loading: true,
            errors: {},
            rolesChecked: {},
            passwordInputType: 'password'
        };
    },
    beforeMount() {
        if (!this.isNew) {
            this.getEmployer();
        } else {
            this.loading = false;
        }
    },
    computed: {
        isNew() {
            return +this.id === 0;
        },
        offices() {
            return this.$store.state.references.offices;
        },
        positions() {
            return this.$store.state.references.positions;
        },
        rolesMap() {
            return this.$store.state.references.roles;
        },
        positionMap() {
            return this.$store.state.references.positionMap;
        },
        showRoles() {
            return Object.keys(this.$store.state.auth.roles).includes('right_setup');
        },
        saveBtnText() {
            return +this.id === 0 ? ' Создать ' : 'Сохранить';
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const approvedRoles = ['office_manager', 'head_office', 'right_setup'];
            const intersection = Object.keys(roles).filter(role => approvedRoles.includes(role));
            return intersection.length > 0;
        },
        canEditPosition() {
            const roles = this.$store.state.auth.roles;
            const restrictedRoles = ['office_manager', 'head_office'];
            return Object.keys(roles).filter(role => restrictedRoles.includes(roles)).length === 0;
        }
    },
    methods: {
        async getEmployer() {
            try {
                const response = await this.$store.dispatch('employers/getEmployer', this.id);
                this.employer = response.data.data;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        onChangePosition() {
            const positionName = this.getPositionName(this.employer.position_id);
            if (this.positionMap[positionName]) {
                this.employer.user_roles = this.positionMap[positionName];
            }
        },
        handleIconClick() {
            this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
        },
        getPositionName(positionId) {
            const position = this.$store.state.references.positions.find(position => position.id === positionId);
            return position ? position.name : '';
        },
        save() {
            this.loading = true;
            const action = this.isNew ? 'createEmployer' : 'updateEmployer';
            this.$store.dispatch('employers/' + action, this.employer).then(
                response => {
                    this.loading = false;
                    if (response.data.success) {
                        if (this.employer.id === this.$store.state.auth.employerId) {
                            //обновим роли, если у себя меняли
                            this.$store.dispatch('getAuth');
                        }
                        this.$router.push({ name: 'employer-card', params: { id: '' + response.data.data.id } });
                    } else {
                        this.errors = response.data.data;
                    }
                },
                error => {
                    this.loading = false;
                    this.errors = error.response.data.errors;
                }
            ).finally(() => { this.loading = false; });
        },
        close() {
            if (this.isNew) {
                this.$router.push({ name: 'employers' });
            } else {
                this.$router.push({ name: 'employer-card', params: { id: '' + this.id } });
            }
        },
        checkViewOffice(role) {
            if (role.type === 'role' && role.children !== undefined && this.employer.roles_offices[role.key] === undefined) {
                this.employer.roles_offices[role.key] = [];
            }
            return this.employer.user_roles.some(item => item === role.title);
        },
        checkboxChange(role) {
            if (this.employer.roles_offices && this.employer.roles_offices[role] !== undefined) {
                this.employer.roles_offices[role] = [];
            }
        }
    }
};
</script>
